












































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import ScrollView from '@/components/ScrollView.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { EBillingBatchHistoryType, IBillingBatchHistory } from '@zunta/configurations'
import { BillingModule } from '@/store/modules/billing.module'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'

@Component({
  components: {
    TextareaV2,
    ModalV2,
    ScrollView,
    DateTimeLabel
  },
  props: {
    batchId: {
      type: Number,
      required: true
    }
  }
})
export default class BillingBatchHistoryModal extends Vue {
  billingModuleInstance: BillingModule = getModule(BillingModule, this.$store)
  historyText: string = ''

  isLoading: boolean = false

  get history () {
    return this.$store.state.billing.billingBatchHistory
  }

  getHistoryLabel (item: IBillingBatchHistory) {
    switch (item.type) {
      case EBillingBatchHistoryType.CREATED:
        return `<span>Batch was generated</span>`
      case EBillingBatchHistoryType.UPDATED:
        return `<span>Batch was updated</span>`
      case EBillingBatchHistoryType.INCOMPLETE:
        return `<span>Batch was Incomplete</span>`
      case EBillingBatchHistoryType.COMPLETE:
        return `<span>Batch was complete</span>`
      case EBillingBatchHistoryType.CUSTOM:
        return `<span>${(item.text || '').replace(/\n/g, '<br/>')}</span>`
      default:
        return '<span>Unknown Action</span>'
    }
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.billingModuleInstance.fetchBillingBatchHistory(this.$props.batchId)
    } finally {
      this.isLoading = false
    }
  }

  async addHistory () {
    if (!this.historyText || !this.historyText.length) {
      return
    }

    try {
      this.isLoading = true
      await this.billingModuleInstance.addBillingBatchHistory({
        text: this.historyText,
        batch: this.$props.batchId,
        type: EBillingBatchHistoryType.CUSTOM
      })
      await this.billingModuleInstance.fetchBillingBatchHistory(this.$props.batchId)
      this.historyText = ''
    } finally {
      this.isLoading = false
    }
  }
}
